import { render, staticRenderFns } from "./AreasEmbargadasTo.vue?vue&type=template&id=3b761c39&lang=pug"
import script from "./AreasEmbargadasTo.vue?vue&type=script&lang=js"
export * from "./AreasEmbargadasTo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports